import React, { useState, useEffect } from "react";

import { Controller, useForm } from "react-hook-form";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import NumberInput from "components/GenericComponent/NumberInput";
import NumberField from "components/GenericComponent/NumberField";
import NumberFormat from "react-number-format";
import { formatNumber, formatMoney } from "utils/currencyFormat";

const DuNoGiamDan = (props) => {
  let {
    data,
    register,
    chonngaygiaodich,
    IsEditChoVay,
    func,
    control,
    errors,
    SuDungPhiPhat_DongLai_TatToan,
    ChoPhepSuaMaHopDong,
  } = props;
  let {
    onChangeNgayVay,
    onChangeAttNumberChoVay,
    onChangeTypePaid,
    onChangeAttTextChoVay,
    onChangeStatusPaidHo,
    onChangeNgayThanhToan,
  } = func;

  let {
    NgayVay,
    ChoVayId,
    Sotienvay,
    StatusPaidHo,
    BocTrongVong,
    CountTypePaid,
    BeforeAfter,
    Note,
    ValueLai,
    TypePaid,
    TienThuHangKy,
    LaiTraGop,
    TienCatTruoc,
    NgayThanhToan,
    PhiThanhToanSom,
    ChiPhiVay,
    ChiPhiVay1,
    PhiBaoHiem,
    Code,
  } = data;
  console.log(
    data,
    "ChoPhepSuaMaHopDongChoPhepSuaMaHopDongChoPhepSuaMaHopDongChoPhepSuaMaHopDong"
  );
  return (
    <>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Ngày vay <span className="canh-bao-red">*</span>
        </label>
        <br />
        <DateTimePicker
          onChange={onChangeNgayVay}
          value={NgayVay}
          // customInputRef={register}
          customInputRef={register({
            required: "Hãy nhập ngày vay",
          })}
          readOnly={!chonngaygiaodich || IsEditChoVay}
          name="NgayVay"
          customInput={<input name="NgayVay" ref={register}></input>}
        ></DateTimePicker>
        <span className="canh-bao-red">
          {errors.NgayVay && errors.NgayVay.message}
        </span>
      </div>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Ngày bắt đầu tính lãi <span className="canh-bao-red">*</span>
        </label>
        <br />
        <DateTimePicker
          onChange={onChangeNgayThanhToan}
          value={NgayThanhToan}
          customInputRef={register}
          readOnly={IsEditChoVay}
          name="NgayThanhToan"
          customInput={<input name="NgayThanhToan" ref={register}></input>}
        ></DateTimePicker>
        <span className="canh-bao-red">
          {errors.NgayVay && errors.NgayVay.message}
        </span>
      </div>
      <div className="col-md-4">
        <TextInputTwoRow
          labelClass="col-md-2 label-control"
          inputClass="form-control input-sm"
          wrapperClass="form-group row"
          labelText="Mã hợp đồng"
          placeholder="Mã hợp đồng"
          inputProps={{
            ref: register,
            name: "Code",
            readOnly: IsEditChoVay,
          }}
        ></TextInputTwoRow>
      </div>
      <div className="col-md-4">
        <NumberInput
          labelClass="col-md-4 label-control"
          inputClass="form-control input-sm"
          inputWrapClass="col-md-8"
          wrapperClass="row"
          labelText="Tổng tiền vay"
          starRed="*"
          placeholder="10,000,000"
          inputProps={{
            name: "Sotienvay",
            value: Sotienvay,
            onChange: onChangeAttNumberChoVay("Sotienvay"),
            rules: {
              required: "Hãy nhập số tiền vay",
            },
            control: control,
            readOnly: IsEditChoVay,
          }}
          error={errors.Sotienvay}
        ></NumberInput>
      </div>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Thời gian vay <span className="canh-bao-red">*</span>
        </label>
        <br />
        <div class="row">
          <div className="col-md-7" style={{ paddingRight: "0px" }}>
            <NumberField
              className="form-control input-sm"
              name={"BocTrongVong"}
              value={BocTrongVong}
              onChange={onChangeAttNumberChoVay("BocTrongVong")}
              // inputRef={register}
              placeholder={"50"}
              inputRef={register({
                required: "Hãy nhập thời gian vay",
              })}
            ></NumberField>
            <span className="canh-bao-red">
              {errors.CountTypePaid && errors.CountTypePaid.message}
            </span>
          </div>
          <div className="col-md-5 color7" style={{ paddingLeft: "10px", paddingTop:"10px" }}>
          {"   "}  Tháng
          </div>
        </div>
        <span className="canh-bao-red">
          {errors.CountTypePaid && errors.CountTypePaid.message}
        </span>
      </div>
      <div className="col-md-4">
        <label className="label-control color7-bold">Chi phí vay</label>
        <br />
        <Controller
          name="ChiPhiVay"
          rules={{
            required: "Hãy nhập số",
          }}
          control={control}
          defaultValue={ChiPhiVay1}
          className="form-control input-sm"
          // onChange, onBlur, value, name, ref inejcted to the component
          as={NumberFormat}
          placeholder={"%"}
        />
      </div>
        {SuDungPhiPhat_DongLai_TatToan &&
          PhiThanhToanSom > 0 &&
          ChoVayId > 0 && (
            <div className="col-md-4">
              <label className="label-control color7-bold">
                Phí thanh toán sớm
              </label>
              <Controller
                name="PhiThanhToanSom"
                control={control}
                defaultValue={formatMoney(PhiThanhToanSom, 2)}
                className="form-control input-sm"
                // onChange, onBlur, value, name, ref inejcted to the component
                as={NumberFormat}
                placeholder={"%"}
              />
            </div>
          )}
        {!SuDungPhiPhat_DongLai_TatToan && (
          <div className="col-md-4">
            <label className="label-control color7-bold">
              Phí thanh toán sớm
            </label>
            <Controller
              name="PhiThanhToanSom"
              control={control}
              defaultValue={formatMoney(PhiThanhToanSom, 2)}
              className="form-control input-sm"
              // onChange, onBlur, value, name, ref inejcted to the component
              as={NumberFormat}
              placeholder={"%"}
            />
          </div>
        )}
        <div className="col-md-4">
          <label className="label-control color7-bold">Phí bảo hiểm</label>
          <Controller
            name="PhiBaoHiem"
            control={control}
            defaultValue={formatMoney(PhiBaoHiem, 2)}
            className="form-control input-sm"
            // onChange, onBlur, value, name, ref inejcted to the component
            as={NumberFormat}
            placeholder={"%"}
          />
        </div>
    </>
  );
};
export default DuNoGiamDan;
